import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { Divider as FrontonDivider, DividerProps } from 'fronton-react';

const divider = css`
  margin: 0;
`;

export const Divider = ({ className, ...rest }: DividerProps) => (
  <FrontonDivider className={cn(divider, className)} {...rest} />
);
